(function ($) {
  'use strict';

  if (typeof this.PersonalityTest === 'function') {
    window.ys.PersonalityTest = new this.PersonalityTest();
  }

  $(window).on('load', function () {
    if (typeof ImageStretch === 'function') {
      // Initialize the image watcher - This class is responsible for watching images inside the defined
      // selectors and then stretching them to the full size of the container
      // The window is being watched for resize events rerun to fit the new container size
      new ImageStretch({
        watched: [
          {
            selector: '#personality-test .bg',
          },
        ],
      });
    }
  });
}).bind(window)(jQuery);
